import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../Context/ContextProvider';

function FormSection() {
    const [data, setData] = useState({
        ask_to: "",
        name: "",
        email: "",
        phoneNumber: "",
        question: ""
    })
    const [errors, setErrors] = useState({});
    const [successMsg, setSuccessMsg] = useState("");
    const { createExpertQuestion, button_loading, error, setError, formatPakistaniPhoneNumber } = useAuth();
    const pages = [
        {
            btn_text: "Explore Biotechnology",
            title: "Biotechnology",

        },
        {
            btn_text: "Discover Genetics",
            title: "Genetics",

        },
        {
            btn_text: "Learn Molecular Biology",
            title: "Molecular Biology",

        },
        {
            btn_text: "Unlock Biochemistry",
            title: "Biochemistry",

        },
        {
            btn_text: "Explore Ecology",
            title: "Ecology",

        },
        {
            btn_text: "Discover Zoology",
            title: "Zoology",

        },
        {
            btn_text: "Learn Botany",
            title: "Botany",

        },
        {
            btn_text: "Explore Microbiology",
            title: "Microbiology",

        },
        {
            btn_text: "Ask Biology Expert",
            title: "Biology",

        }
    ]
    const params = useParams()
    useEffect(() => {
          const filterData=pages.find((item)=>item.title?.toLowerCase()===params.slug.replace(/-/g, " "))
          if(filterData){
              setData(prev=>({...prev,ask_to:filterData?.title}))
          }
          else{
            setData(prev=>({...prev,ask_to:""}))
          }
    }, [params.slug])

    const validate = () => {
      let errs = {};
      if (!data.name) errs.name = 'Name is required.';
      if (!data.email) errs.email = 'Email is required.';
    //   if (!data.phoneNumber) errs.phoneNumber = 'Phone number is required.';
      if (!data.question) errs.question = 'Question is required.';
      if(!data?.question?.length>50) errs.question = 'Question should not exceed 50 words.';
      if (!data.ask_to || data.ask_to === "select an expert") errs.ask_to = 'Expert selection required.';
      setErrors(errs); return Object.keys(errs).length === 0;
    }

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: undefined });
        setError && setError({message:'', color:''}) // clear global error
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMsg("");
        if (!validate()) return;
        const resp = await createExpertQuestion(data);
        if (resp.success) {
            setSuccessMsg("Question submitted successfully!");
            setData({ ask_to: data.ask_to, name: '', email: '', phoneNumber: '', question: '' });
        }
    };
    return (
        <div className='form_section mb-5'>
            <h5>Ask, Learn, and Explore</h5>
            <form className='form' onSubmit={handleSubmit}>
                <div className='inp_box'>
                    <label>Name<span className='text-danger'>*</span></label>
                    <input name="name" value={data.name} onChange={handleChange} placeholder='Name' />
                    {errors.name && <div className="text-danger small">{errors.name}</div>}
                </div>
                <div className='inp_box'>
                    <label>Email<span className='text-danger'>*</span></label>
                    <input name="email" value={data.email} onChange={handleChange} placeholder='jhon@gmail.com' />
                    {errors.email && <div className="text-danger small">{errors.email}</div>}
                </div>
                <div className='inp_box'>
                    <label>Ask to<span className='text-danger'>*</span></label>
                    {params?.slug!=="other"?<select name="ask_to" onChange={handleChange} style={{cursor:`${params?.slug!=="other"?"not-allowed":"pointer"}`}} disabled={params?.slug!=="other"?true:false} value={data.ask_to}>
                        <option>select an expert</option>
                        {pages?.map((item)=>(
                            <option key={item.title} value={item?.title}>{item?.title}</option>
                        ))}
                    </select>:<input name="ask_to" value={data.ask_to} onChange={handleChange} placeholder='Ask to an expert' />}
                    {errors.ask_to && <div className="text-danger small">{errors.ask_to}</div>}
                </div>
                {/* <div className='inp_box'>
                    <label>Phone Number<span className='text-danger'>*</span></label>
                    <input name="phoneNumber" value={data.phoneNumber} onChange={(e)=>setData({...data, phoneNumber: formatPakistaniPhoneNumber(e.target.value)})} placeholder='3120123456' />
                    {errors.phoneNumber && <div className="text-danger small">{errors.phoneNumber}</div>}
                </div> */}
                <div className='inp_box mb-3'>
                    <label>Question<span className='text-danger'>*</span></label>
                    <textarea name="question" value={data.question} onChange={handleChange} placeholder='Type your question here...' />
                    {errors.question && <div className="text-danger small">{errors.question}</div>}
                </div>
                <div className='modal_bottom'>
                    <button className="submit_btn" type="submit" disabled={button_loading}>{button_loading ? 'Submitting...' : 'Submit'}</button>
                </div>
            </form>
        </div>
    )
}

export default FormSection